// Match the backend's secure default: production requires verification unless
// the build explicitly configures a policy. Development and QA can still opt
// out for isolated test accounts/backends.
const configuredPolicy = process.env.REACT_APP_REQUIRE_VENUE_EMAIL_VERIFICATION;

export const requiresVenueEmailVerification = configuredPolicy === 'true' || (
    configuredPolicy === undefined && process.env.NODE_ENV === 'production'
);
